// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"67c46ed9","215":"1f818357","645":"3221bcac"}[chunkId] + ".chunk.css";
};